import DataLayer from '../data'

export default ({ debug, store, eventbus }) => {
    return new Promise((res) => {
      debug && console.log('bootstrap.reset', 'init');
      
      const dl = new DataLayer();

      eventbus.$on('sayl-oat.reset', ({resolve, rej}) => {
        dl.reset({ store })
        .then(resolve)
        .catch(reject);
      });
      
      res();
       
      debug && console.log('bootstrap.reset', 'completed');
    })
}
